import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule as ACommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { UserService } from './user.service';

import { TYTCommonModule } from '../common';
import { ApiModule } from '../api';
import { ValidationModule } from '../validation';
import { LogoutComponent } from './logout/logout.component';

const COMPONENTS = [
    LoginComponent,
    LogoutComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        FormsModule,
        ACommonModule,
        RouterModule,
        TYTCommonModule,
        ApiModule,
        ValidationModule
    ],
    exports: COMPONENTS
})
export class UserModule { 
  static forRoot(): ModuleWithProviders<UserModule> {
    return {
        ngModule: UserModule,
        providers: [
            UserService
        ]
    };
}
}
